export type BulkOperationStatus = 'QUEUED' | 'IN_PROGRESS' | 'COMPLETE' | 'FAILED';

export enum BulkChatAction {
  UNASSIGN = 'unassign',
  ASSIGN = 'assign',
  ADD_TAGS = 'add_tags',
  ADD_MEMBERS = 'add_members',
  MARK_AS_DONE = 'mark_as_done',
}

export interface BulkOperationsStatusPayload {
  operationId: string;
  orgId: string;
  status: BulkOperationStatus;
  type: string;
  validUserIds?: string[];
  additionalData: {
    action: BulkChatAction;
    total: number;
    succeeded: number;
    failed: number;
  };
}

export interface BulkOperationState {
  operationId: string;
  status: BulkOperationStatus;
  action: BulkChatAction;
  total: number;
  succeeded: number;
  failed: number;
}
